import { clone } from '@edicom/common/object/clone';

export function createState(originalState = {}, view = {}, isRegister, onStateUpdated) {
  const state = clone(originalState);
  let isUpdated = '';
  // @odeniel: para tener state en nivel root
  view.name = view.name || 'root';
  view.type = view.type || 'root';
  const rootState =
    state[view.name] &&
    state[view.name].reduce((acc, rootProperty) => {
      acc[rootProperty.name] = rootProperty;
      return acc;
    }, {});
  state[view.name] = [];

  view.name !== 'root' &&
    Object.defineProperty(state, 'root', {
      get: () => state[view.name],
    });

  flat(view, mapProperties, { isRoot: true });
  isUpdated && onStateUpdated(state);
  return state;

  //////////////////////////////////////////////////////////////////////////////

  function mapProperties(viewProperty, { isSection }) {
    if (!_isRegisterValid(viewProperty)) {
      return;
    }
    const isExistRegisterState = !!state[viewProperty.name];
    const isTypeGrid = _isGrid(viewProperty);

    if (isExistRegisterState) {
      // eliminar los campos del state que ya no existen en el view
      const filteredState = filterOldFields(viewProperty, state[viewProperty.name]);
      // añadir los nuevos campos en el view al final del state
      state[viewProperty.name] = addNewFields(viewProperty, filteredState, isTypeGrid);
    } else {
      // añadir todos los campos del view en el state si son hidden o del grid
      state[viewProperty.name] = mapAllFields(viewProperty, isTypeGrid);
    }

    if (isSection && viewProperty.type === 'collapse' && viewProperty.metadata) {
      viewProperty.metadata = viewProperty.metadata || {};
      if (rootState && rootState[viewProperty.name]) {
        state[view.name].push(rootState[viewProperty.name]);
        viewProperty.metadata.open = rootState[viewProperty.name].open;
      } else {
        const isOpen = viewProperty.metadata.open === true || viewProperty.metadata.open === 'true' ? viewProperty.metadata.open : false;
        state[view.name].push({
          name: viewProperty.name,
          open: isOpen,
          hide: false, // por defecto dejamos todas las secciones visibles
        });
        viewProperty.metadata.open = isOpen; //@amoncholi: con esta asignación estamos sobreescribiendo el valor del view.
      }
    }
    state[viewProperty.name].isTypeGrid = isTypeGrid;
    state[viewProperty.name].total = (viewProperty.properties || []).length;

    //////////////////////////////////////////////////////////////////////////

    function filterOldFields(viewProperty, currentState) {
      // borrar del state los campos que ya no estan en el view
      return currentState.reduce((acc, stateField) => {
        if (!stateField) {
          return acc; // filtramos stateField a null o undefined
        }
        const property = (viewProperty.properties || []).find(property => property.name === stateField.name);
        if (property && property.type !== 'hidden') {
          // si el campo state sigue existiendo en el view lo dejamos en el state:
          if (stateField.model) {
            // @odeniel es para migrar los viejos state con "model" to "name"
            isUpdated += `state model updated to name ${stateField.model}\n`;
            stateField.name = stateField.name || stateField.model;
            delete stateField.model;
          }
          acc.push(stateField); // {name, hide:true, [width:200]}
        } else {
          // el campo no existe ya en el view, lo borramos
          isUpdated += `old fields deleted ${stateField.name || stateField.model}\n`;
        }
        return acc;
      }, []);
    }

    function addNewFields(viewProperty, currentState, isTypeGrid) {
      // añadir en el state los campos nuevos del view
      const acc = [];
      (viewProperty.properties || [])
        .filter(property => property.name && property.type !== 'hidden')
        .forEach(property => {
          const isExist = !!currentState.find(f => f.name === property.name);
          if (isExist) {
            return;
          }

          const hide = !!(viewProperty.hidden || []).find(name => name === property.name);
          if (isTypeGrid || hide) {
            // añadimos solo los campos hidden (o del grid que debemos tener el registro completo)
            isUpdated += `new fields added ${property.name}\n`;
            _pushStateField(acc, _createStateField(property, hide, isTypeGrid));
          }
        });
      return [...currentState, ...acc];
    }

    function mapAllFields(viewProperty, isTypeGrid) {
      // añadir todos los campos hidden o del grid en un nuevo register state
      return (viewProperty.properties || [])
        .filter(property => property.name && property.type !== 'hidden')
        .reduce((acc, property) => {
          if (property.type === 'hidden') {
            return acc;
          } // @odeniel los tipos "hidden" no se tratan en state
          const hide = !!(viewProperty.hidden || []).find(name => name === property.name);
          if (isTypeGrid || hide) {
            // añadimos solo los campos hidden (o del grid que debemos tener el registro completo)
            _pushStateField(acc, _createStateField(property, hide, isTypeGrid));
          }
          return acc;
        }, []);
    }

    function _pushStateField(acc, stateField) {
      if (stateField) {
        acc.push(stateField);
      }
    }

    function _createStateField({ name, cols = 2 }, hide, isTypeGrid) {
      if (isTypeGrid) {
        const width = (cols || 2) * 100;
        return { name, hide, width };
      }
      if (!hide) {
        return null;
      } // si no es grid ni escondido, no hace falta guardar el campo
      return { name, hide };
    }

    function _isGrid({ type = '' } = {}) {
      return 'array, array2, group'.includes(type);
    }

    function _isRegisterValid(viewProperty) {
      if (!isRegister(viewProperty)) {
        return false;
      }
      if (!viewProperty.name && !viewProperty.type) {
        return false;
      } // 'type toolbar con properties en metada, lo saltamos sin error'
      if (!viewProperty.name) {
        return console.error(`"viewProperty.name" missing in viewProperty:`, viewProperty);
      }
      return true;
    }
  }

  function flat(viewProperty, callback, { isRoot = false, isSection = false }) {
    callback(viewProperty, { isRoot, isSection });
    isSection = false;
    if (isRoot) {
      isSection = true;
    }
    isRoot = false;
    (viewProperty.properties || []).forEach(viewChild => flat(viewChild, callback, { isRoot, isSection }));
  }
}
